import CardFreshnessStamp from './CardFreshnessStamp';

export default CardFreshnessStamp;

export type { CardFreshnessLabel, ICardFreshnessStampProps } from './CardFreshnessStamp';
